import { CallApiLogout } from "../../Api/Enforcement";
import { handleClearStoredAuth, notifyClientAuthChanged } from "./Storage";

export function handleClientLogout(onComplete) {
  CallApiLogout(() => {
    handleClearStoredAuth();
    notifyClientAuthChanged();
    onComplete?.();
  });
}
